<template>
  <nav-bar />
  <div class="page">
    <router-view/>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import { defineComponent } from 'vue'

export default defineComponent({
  components: {
    NavBar
  },
  mounted () {
    this.mobileWidthHandler()
  },
  methods: {
    mobileWidthHandler () {
      if (window.innerWidth <= 900) {
        this.$store.commit('global/SET_IS_MOBILE', true)
      }

      window.addEventListener('resize', () => {
        if (window.innerWidth <= 900 && !this.$store.state.global.isMobile) {
          this.$store.commit('global/SET_IS_MOBILE', true)
        } else if (window.innerWidth > 900 && this.$store.state.global.isMobile) {
          this.$store.commit('global/SET_IS_MOBILE', false)
        }
      })
    }
  }
});

</script>

<style lang="scss">
@import "@/styles/index.scss";
@import "@/styles/global/_variables.scss";
.page{
  @media screen and (max-width: $breakpoint){
    margin-top: $navbar-height-mobile;
  }
}
</style>
